export const BUSINESS_TX_TABLE_SORT_ENABLED = 'BUSINESS_TX_TABLE_SORT_ENABLED'
export const BUSINESS_TX_TABLE_SORT_DISABLED = 'BUSINESS_TX_TABLE_SORT_DISABLED'
export const BUSINESS_TX_TABLE_SORT_NAME = 'name'
export const BUSINESS_TX_TABLE_SORT_STATUS = 'status'
export const BUSINESS_TX_TABLE_SORT_CREATED = 'created'

function enable(sortField, order) {
  return {
    type: BUSINESS_TX_TABLE_SORT_ENABLED,
    sortField,
    order,
  }
}

function disable() {
  return {
    type: BUSINESS_TX_TABLE_SORT_DISABLED,
  }
}

export function enableBusinessTransactionSort(sortField, order) {
  return (dispatch) => {
    dispatch(enable(sortField, order))
  }
}

export function disableBusinessTransactionSort() {
  return (dispatch) => {
    dispatch(disable())
  }
}
